module.exports = __webpack_public_path__ + "static/media/QualificationUpload_Template.24220e21.xlsx";